import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export function usePush(enabled) {
  const [state, setState] = useState("idle");

  const subscribe = useCallback(async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) return setState("unsupported");
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return setState("denied");
      const { data } = await api.get("/public/config");
      const reg = await navigator.serviceWorker.ready;
      let sub = await reg.pushManager.getSubscription();
      if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.vapid_public_key) });
      await api.post("/push/subscribe", { subscription: sub.toJSON() });
      setState("subscribed");
    } catch (e) {
      setState("error");
    }
  }, []);

  useEffect(() => {
    if (enabled && "Notification" in window && Notification.permission === "granted") subscribe();
  }, [enabled, subscribe]);

  return { pushState: state, subscribePush: subscribe };
}
